/* eslint-disable no-param-reassign */
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import AuthService from 'Services/auth';
import { BASE_URL } from 'Config';

export const service = axios.create({
  baseURL: `${BASE_URL}/api/v2`,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'es',
  },
});

export const serviceVersionOne = axios.create({
  baseURL: `${BASE_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'es',
  },
});

const _handleRequest = async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  const session = await AuthService.getCurrentSession();
  if (!session) {
    return config;
  }
  if (config.headers) {
    config.headers.Authorization = session.getIdToken().getJwtToken();
  }
  return config;
};

const _handleSuccess = async (response: AxiosResponse): Promise<AxiosResponse | undefined> => {
  if (response.status === 202 || response.status === 204) {
    return undefined;
  }
  return response.data;
};

const _handleError = async (error: Error): Promise<Error> => {
  return Promise.reject(error);
};

service.interceptors.request.use(_handleRequest);
service.interceptors.response.use(_handleSuccess, _handleError);

serviceVersionOne.interceptors.request.use(_handleRequest);
serviceVersionOne.interceptors.response.use(_handleSuccess, _handleError);
